import { type Modification, type Modifiers } from '../../types';
import { generateAdditions } from './additions';
import { generateRemovals } from './removals';
import { generateSubstitutionsAndUpdateOthers } from './substitutions';

// ─────────────────────────────────────────────────────────────────────────────

/**
 * Generates a set of modifiers based on the initial and active modifications.
 */
export function generateDerivedModifiers(
  initialModifications: Modification[],
  activeModifications: Modification[],
  isUpsellPricingEnabled?: boolean,
): Modifiers {
  const initialAdditions = generateAdditions({
    initialModifications,
    activeModifications,
  });
  const initialRemovals = generateRemovals({
    initialModifications,
    activeModifications,
  });

  return generateSubstitutionsAndUpdateOthers({
    additions: initialAdditions,
    removals: initialRemovals,
    isUpsellPricingEnabled,
  });
}
